import React, { useState, useEffect, useMemo, createContext } from 'react';

// Must match Tailwind's `md` breakpoint (768px): Aside/MobileHeader switch on `md:` classes,
// so a narrower query here left 641–767px viewports (phones in landscape) with the desktop
// sidebar logic but the mobile full-width aside — it never auto-collapsed and never closed
// after a nav tap.
const MOBILE_QUERY = '(max-width: 767px)';

export const SizeContext = createContext();

export const SizeProvider = ({ children }) => {
  const [mediaQuery] = useState(() => window.matchMedia(MOBILE_QUERY));
  const [isMobile, setIsMobile] = useState(() => mediaQuery.matches);

  useEffect(() => {
    const handler = (e) => setIsMobile(e.matches);
    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }, [mediaQuery]);

  const value = useMemo(() => ({ isMobile }), [isMobile]);
  return <SizeContext.Provider value={value}>{children}</SizeContext.Provider>;
};
